import axios from 'axios';
import { normalizeBacEnrollmentRows, PROGRAM_CODE_MAP } from '../../utils/dataNormalizer';

const normalizeSingleDealerRows = (data, programName) => {
    if (Array.isArray(data?.enrollments)) {
        return normalizeBacEnrollmentRows(data);
    }
    if (!data || typeof data !== 'object') {
        return [];
    }
    return [
        {
            ...data,
            programName: data.programName || programName,
            programCode: data.programCode || data.programCd || PROGRAM_CODE_MAP[programName] || data.program,
        },
    ];
};

export const singleDealerLookup = async ({ programName, bac }) => {
    if (!programName || bac === undefined || bac === null || bac === '') {
        throw new Error('Program name and BAC are required.');
    }
    const normalizedBac = String(bac).trim();
    const { data } = await axios.get(
        `/api/enrollment-report/program/${encodeURIComponent(programName)}/dealer/${encodeURIComponent(normalizedBac)}`
    );
    const normalizedRows = normalizeSingleDealerRows(data, programName);
    return normalizedRows.map((row) => ({
        ...row,
        programName: row.programName || programName,
        programCode: row.programCode || data?.programCd || PROGRAM_CODE_MAP[programName] || row.program,
    }));
};

export const getDealerHistory = async (bac, programName) => {
    const params = programName ? { programName } : undefined;
    const { data } = await axios.get(`/api/enrollment-history/${encodeURIComponent(bac)}`, { params });
    return data;
};

export const getDealerCleanHistory = async (bac, programName) => {
    const params = programName ? { programName } : undefined;
    try {
        const { data } = await axios.get(`/api/enrollment-history-clean/${encodeURIComponent(bac)}`, { params });
        return data;
    } catch (error) {
        // During local rollouts, the frontend can update before the backend container
        // restarts. Fall back to the legacy history endpoint instead of surfacing 404 noise.
        if (error?.response?.status === 404) {
            return getDealerHistory(bac, programName);
        }
        throw error;
    }
};

export const fetchDealerProgramSelections = async ({
    programName,
    bac,
    preferCache = false,
    cacheOnly = false,
}) => {
    if (!programName || !bac) {
        throw new Error('Program name and BAC are required to refresh dealer selections.');
    }
    const params = {};
    if (preferCache) params.preferCache = true;
    if (cacheOnly) params.cacheOnly = true;
    const { data } = await axios.get(
        `/api/enrollment-report/program/${encodeURIComponent(programName)}/dealer/${encodeURIComponent(bac)}`,
        { params: Object.keys(params).length ? params : undefined }
    );
    return data;
};
